export const GET_CART_REQ = "GET_CART_REQ";
export const GET_CART_SUCCESS = "GET_CART_SUCCESS";
export const GET_CART_ERROR = "GET_CART_ERROR";

export const ADD_TO_CART_REQUEST = "ADD_TO_CART_REQUEST";
export const ADD_TO_CART_SUCCESS = "ADD_TO_CART_SUCCESS";
export const ADD_TO_CART_FAILURE = "ADD_TO_CART_FAILURE";

export const DEL_CART_REQ = "DEL_CART_REQ";
export const DEL_CART_SUCCESS = "DEL_CART_SUCCESS";
export const DEL_CART_ERROR = "DEL_CART_ERROR";
